import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';
import ListController from "./ListController";
import EditController from "./EditController";
import TxnTemplateView from "./TxnTemplateView";
import ListComponent from "./ListComponent";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('txnTemplate', {
                url: '/txnTemplate',
                abstract: true,
            })
            .state('txnTemplate.list', {
                url: '',
                template: require('./List.html'),
                controller: ListController,
                controllerAs: 'vm',
                data: {title: 'Template List'}
            })

            .state('txnTemplate.list.view', {
                url: '/view/:txnTemplateGuid',
                onEnter: function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        component: 'txnTemplateViewModal',
                        size: 'lg',
                        resolve: {
                            txnTemplateGuid: () => $stateParams.txnTemplateGuid
                        }
                    }).result.finally(() => $state.go('^'));
                }
            })

            .state('txnTemplate.edit', {
                url: '/edit/:txnTemplateGuid',
                template: require('./Edit.html'),
                controller: EditController,
                controllerAs: 'vm',
                data: {title: 'Edit Template'}
            })
            .state('txnTemplate.create', {
                url: '/create',
                template: require('./Edit.html'),
                controller: EditController,
                controllerAs: 'vm',
                data: {title: 'Create Template'}
            })


    }
}

export default angular.module('app.txnTemplate', [
    TxnTemplateView,
    ListComponent,
])
    .config(Routes)

    .name;
